import { render, staticRenderFns } from "./RemoteListHeader.vue?vue&type=template&id=ba83b62e&scoped=true"
import script from "./RemoteListHeader.vue?vue&type=script&lang=ts"
export * from "./RemoteListHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba83b62e",
  null
  
)

export default component.exports